export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export enum ASSEMBLY_TAG_LIST_COLUMN {
  NAME = 'name',
  ASSEMBLIES_COUNT = 'assembly_count',
  ACTIONS = 'actions',
}

export interface Column {
  label: string;
  key: ASSEMBLY_TAG_LIST_COLUMN;
  sortIcon: boolean;
}
